import { ToastTypeEnum } from "context/toastContext";
import fetchWithAuthRetry from "helpers/fetch/fetchRefreshToken";
import { downloadFile } from "./downloadFile";

interface DownloadFileOptions {
  url: string;
  filename: string;
  addToast: (arg: { text: string; type: ToastTypeEnum }) => void;
  body?: Record<string, unknown>;
  onError?: () => void;
  signal?: AbortSignal;
}

const downloadFileWithAuthRetry = async ({
  url,
  filename,
  addToast,
  body,
  onError = () => addToast({ text: "Произошла ошибка. Попробуйте позже", type: ToastTypeEnum.ERROR }),
  signal,
}: DownloadFileOptions): Promise<void> => {
  try {
    const response = await fetchWithAuthRetry(url, {
      method: "POST",
      headers: {
        ...(body ? { "Content-Type": "application/json" } : {}),
      },
      body: body ? JSON.stringify(body) : undefined,
      signal,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(JSON.stringify(errorData));
    }

    const blob = await response.blob();
    downloadFile({ blob, filename });
  } catch (error) {
    try {
      const parsed = error instanceof Error ? JSON.parse(error.message) : null;
      if (parsed?.error === "NOT_IN_COMPANY_ENVIRONMENT") {
        addToast({
          type: ToastTypeEnum.ERROR,
          text: "У текущей компании нет доступа к этому отчету",
        });
      } else {
        onError();
        console.error("Произошла другая ошибка:", parsed);
      }
    } catch (e) {
      onError();
      console.error("Ошибка при обработке данных ошибки:", e);
    }
  }
};

export default downloadFileWithAuthRetry;
